import React from 'react';
import { Typography } from 'fronton-react';
import {
	otherServicesStyles,
	otherServicesWrapperStyles,
	otherServicesContainerStyles,
} from './style';
import { Service } from './components/service';
import { services } from './other-services-db';
import { Carousel } from './components/carousel';

export const OtherServices = () => (
	<div className={otherServicesStyles}>
		<div className={otherServicesWrapperStyles}>
			<Typography variant="h2">Другие услуги</Typography>
			<div className={otherServicesContainerStyles}>
				{services.map(el => (
					<Service {...el} key={el.name} />
				))}
			</div>
			<Carousel />
		</div>
	</div>
);
